<template>
    <div>
		<Modal :open-state="showModal" @close="() => showModal = false">
			<div class="check-modal">
				<Loader v-show="isLoading" :loading="isLoading"/>
				<div v-if="!isLoading">

					<div class="check-modal__head">
						Игра #<span class="check-modal__game-id">{{ game.id }}</span>
					</div>
					<div class="check-modal__info">
						<div class="check-modal__info-item">
							<div class="check-modal__info-label">Ставка</div>
							<div class="check-modal__info-value">{{ game.bet }}</div>
						</div>
						<div class="check-modal__info-item">
							<div class="check-modal__info-label">Коэффициент</div>
							<div v-if="game.name === 'dice'" class="check-modal__info-value">x{{ (100 / game.chance) }}</div>
							<div v-else-if="game.name === 'coin'" class="check-modal__info-value">x{{ (game.coefficient) }}</div>
							<div v-else class="check-modal__info-value">x{{ game.chance }}</div>
						</div>
						<div class="check-modal__info-item">
							<div class="check-modal__info-label">Результат</div>
							<div class="check-modal__info-value" :class="[game.win > 0 ? 'text-success' : '']">{{ game.win }}</div>
						</div>
					</div>

					<div v-if="game.name === 'dice'">
						<div v-if="!game.side">
							<div class="show-container-m" style="margin-top:50px">
								<div class="progress-m" id="progressBar">
									<div
										:class="[game.win > 0 ? 'text-success' : '', game.win > 0 ? 'progress-number-m-win' : 'progress-number-m']"
										:aria-valuenow="game.random"
										:style="'left: '+ game.random / 9999.99 +'%;'"></div>
									<div class="rounded-m">
										<div class="progress-bar-m" :style="'width: '+ width +'%;'"
											 aria-valuenow="0"
											 aria-valuemin="0" aria-valuemax="100">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="show-container-m" style="margin-top:50px">
								<div class="progress-m-max">
									<div
										:class="[game.win > 0 ? 'text-success' : '', game.win > 0 ? 'progress-number-m-win' : 'progress-number-m']"
										:aria-valuenow="game.random"
										:style="'left: '+ game.random / 9999.99 +'%;'"></div>
									<div class="rounded-m-max">
										<div class="progress-bar-m-max" :style="'width: '+ width +'%;'"
											 aria-valuenow="0"
											 aria-valuemin="0" aria-valuemax="100">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else-if="game.name === 'coin'">
						<div class="check-modal__title">
							Ваш выбор
						</div>
						<div class="noDrop coin-wrapper">
							<div class="coin__side" :style="{backgroundImage: `url(/images/${game.side  ? 'head' : 'tail'}1.png)`}"></div>
						</div>
					</div>
					<div v-else>
						<div class="mines__grid">
							<div class="mines__row" v-for="blockKey in 5">
								<template v-for="bombKey in 5">
									<div class="mines__cell mines__cell--success mines__cell--disabled" v-if="game.bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === false && typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-success"></use></svg>
									</div>
									<div class="mines__cell mines__cell--danger mines__cell--disabled" v-else-if="game.bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === true && typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-danger"></use></svg>
									</div>
									<div class="mines__cell mines__cell--success" v-else-if="game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === false">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-success"></use></svg>
									</div>
									<div class="mines__cell mines__cell--danger" v-else-if="game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === true">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-danger"></use></svg>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
    </div>
</template>

<script>
    import Modal from "../blocks/Modal.vue";
	import Loader from "../blocks/Loader.vue";

	export default {
		components: {
			Loader,
			Modal
		},
        data() {
            return {
                isLoading: true,
                clipboard: null,
                game: null,
                width: 0,
                counterBombs: 0,
                counterBombsBlock: [],
                side: null,
				showModal: false
            }
        },
        mounted() {
			this.$root.emitter.on('showGame', (obj) => {
                this.isLoading = true;

				this.showModal = true;
   
                this.getGame(obj.id, obj.game);
            });
        },
        methods: {
            getGame(id, game) {
                this.clipboard = new ClipboardJS('.fsh');
                this.$root.graphql.getGameHistory({
                    id: id,
                    game: game
                }).then(res => {
                    this.game = res;

                    if (this.game.name === 'dice') {
                        if (!this.game.side) {
                            this.width = this.game.chance;
                        } else {
                            this.width = 100 - this.game.chance;
                        }
                    } 

                    this.isLoading = false;
                }).catch(error => {
					this.showModal = false;

                    this.isLoading = false;
                });
            },
            setCounterBombKeys(key) {
                if (typeof this.counterBombsBlock[key] === 'undefined') {
                    this.counterBombs++

                    this.counterBombsBlock[key] = this.counterBombs;

                    return this.counterBombsBlock[key];
                } else {
                    return this.counterBombsBlock[key];
                }
            }
        }
    }
</script>